import React, { useState } from 'react';

const StagingUpsellModal = ({ isOpen, onClose, onSelectStaging, listingId }) => {
  const [selectedPlan, setSelectedPlan] = useState('5-pack');

  const stagingPlans = [
    {
      id: '1-image',
      title: '1 kép',
      price: 990,
      images: 1,
      recommended: false,
      perImage: 990
    },
    {
      id: '5-pack',
      title: '5 kép csomag',
      price: 3990,
      images: 5,
      recommended: true,
      perImage: 798,
      savings: '20% megtakarítás'
    },
    {
      id: '10-pack',
      title: '10 kép csomag',
      price: 6990,
      images: 10,
      recommended: false,
      perImage: 699,
      savings: '30% megtakarítás'
    }
  ];

  const handleRequest = () => {
    const plan = stagingPlans.find(p => p.id === selectedPlan);
    onSelectStaging(plan);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto border-2 border-white/[0.08] shadow-2xl">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-purple-600 to-pink-600 p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2">
                🎨 Professzionális megjelenés
              </h2>
              <p className="text-white/90">
                AI staging - Üres lakásból álomotthon percek alatt
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white/20 rounded-full p-2 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Before/After Preview */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-4 border-2 border-white/10">
              <div className="text-center mb-2">
                <span className="text-red-400 font-bold text-sm">❌ ELŐTTE</span>
              </div>
              <div className="aspect-video bg-gray-700 rounded-lg flex items-center justify-center">
                <span className="text-gray-500 text-4xl">🏚️</span>
              </div>
              <p className="text-gray-400 text-xs mt-2 text-center">Üres, hideg</p>
            </div>
            <div className="bg-gradient-to-br from-purple-900/30 to-pink-900/30 rounded-xl p-4 border-2 border-purple-500/30">
              <div className="text-center mb-2">
                <span className="text-green-400 font-bold text-sm">✓ UTÁNA</span>
              </div>
              <div className="aspect-video bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center">
                <span className="text-4xl">🏡</span>
              </div>
              <p className="text-gray-300 text-xs mt-2 text-center">Otthonos, meleg</p>
            </div>
          </div>

          {/* Plans */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            {stagingPlans.map((plan) => (
              <div
                key={plan.id}
                onClick={() => setSelectedPlan(plan.id)}
                className={`relative cursor-pointer rounded-2xl p-6 border-2 transition-all duration-300 ${
                  selectedPlan === plan.id
                    ? 'border-purple-500 scale-105 shadow-2xl shadow-purple-500/30'
                    : 'border-white/[0.08] hover:border-white/40'
                } ${plan.recommended ? 'ring-4 ring-yellow-400/50' : ''}`}
              >
                {/* Recommended Badge */}
                {plan.recommended && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-yellow-400 to-amber-500 text-black text-xs font-black px-4 py-1 rounded-full shadow-lg">
                    NÉPSZERŰ
                  </div>
                )}

                {/* Radio Button */}
                <div className="absolute top-4 right-4">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                    selectedPlan === plan.id ? 'border-purple-500 bg-purple-500' : 'border-white/40'
                  }`}>
                    {selectedPlan === plan.id && (
                      <div className="w-3 h-3 rounded-full bg-white" />
                    )}
                  </div>
                </div>

                {/* Plan Content */}
                <div className="text-center">
                  <div className="text-white font-bold text-lg mb-2">{plan.title}</div>
                  <div className="text-3xl font-black text-white mb-1">
                    {plan.price.toLocaleString()} Ft
                  </div>
                  <div className="text-gray-400 text-sm mb-2">
                    {plan.perImage.toLocaleString()} Ft / kép
                  </div>
                  {plan.savings && (
                    <div className="bg-green-500/20 text-green-300 text-xs font-bold px-3 py-1 rounded-full inline-block">
                      {plan.savings}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Stats */}
          <div className="bg-gradient-to-r from-green-500/20 to-emerald-500/20 backdrop-blur-xl rounded-xl p-6 border border-green-500/30 mb-6">
            <h3 className="text-white font-black text-lg mb-4 text-center">📊 Staging hatása</h3>
            <div className="grid grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-3xl font-black text-white mb-1">+40%</div>
                <div className="text-gray-300 text-sm">Több érdeklődő</div>
              </div>
              <div>
                <div className="text-3xl font-black text-white mb-1">2x</div>
                <div className="text-gray-300 text-sm">Gyorsabb eladás</div>
              </div>
              <div>
                <div className="text-3xl font-black text-white mb-1">+15%</div>
                <div className="text-gray-300 text-sm">Magasabb ár</div>
              </div>
            </div>
          </div>

          {/* Info */}
          <div className="bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-xl rounded-xl p-4 border border-blue-500/30 mb-6">
            <div className="flex items-start gap-3">
              <span className="text-2xl">💡</span>
              <div>
                <h4 className="text-white font-bold mb-1">Mi az AI staging?</h4>
                <p className="text-gray-300 text-sm">
                  Az üres vagy rendezetlen szobákat AI-val berendezzük, hogy a vevők könnyebben el tudják képzelni az otthonukat.
                </p>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="flex-1 bg-white/10 hover:bg-white/20 text-white font-bold py-4 rounded-xl transition-colors border-2 border-white/[0.08]"
            >
              Most kihagyom
            </button>
            <button
              onClick={handleRequest}
              className="flex-1 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-pink-600 hover:to-purple-600 text-white font-black py-4 rounded-xl shadow-xl hover:shadow-2xl hover:shadow-purple-500/50 transition-all"
            >
              Kérem a staginget! 🎨
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StagingUpsellModal;
